import { createContext } from 'react';

import {
  Organization,
  OrganizationInput,
} from '@totem/components/orgManagement/types';

interface Context {
  loading: boolean;
  data: Organization[];
  filteredData: Organization[];
  action: string;
  actionItem: Organization;
  onAction: (action: string, selectedOrg: Organization) => void;
  input: OrganizationInput;
  setInput: (input: OrganizationInput) => void;
  onUpdateNetSuiteKey: (
    action: string,
    organizationId: string,
    netSuiteKey: string,
  ) => void;
}

export default createContext<Context>({
  loading: false,
  data: null,
  filteredData: null,
  action: '',
  actionItem: null,
  onAction: () => {},
  input: {},
  setInput: () => {},
  onUpdateNetSuiteKey: () => {},
});
